import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  Input,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { CoinHelperService } from "../../services/helper/coin-helper.service";
import { coinsService } from "../../services/coins.service";

@Component({
  selector: "app-advance-filters",
  templateUrl: "./advance-filters.component.html",
  styleUrls: ["./advance-filters.component.scss"],
  standalone: false,
})
export class AdvanceFiltersComponent implements OnInit, OnChanges {
  @Input() restoredFilters: any = {};
  @Output() filtersChanged = new EventEmitter<any>();
  filters = [];
  isLoad: boolean = false;
  constructor(
    public coinHelper: CoinHelperService,
    private coinService: coinsService
  ) {}

  ngOnInit(): void {
    this.getCoinFilterOptions();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes["restoredFilters"] && this.isLoad) {
      this.applyRestoredFilters(changes["restoredFilters"].currentValue);
    }
  }
  getCoinFilterOptions() {
    this.coinService.getCoinsFilterOptions().subscribe((res) => {
      let { years, mints, types, denominations, proofs, varietys } = res.data;
      years = years.sort((a, b) => a - b);
      this.filters = [
        {
          id: "year",
          label: "Year",
          name: "year",
          options: years,
          selectedValue: null,
        },
        {
          id: "mint",
          label: "Mint",
          name: "mint",
          options: mints,
          selectedValue: null,
        },
        {
          id: "type",
          label: "Type",
          name: "type",
          options: types,
          selectedValue: null,
        },
        {
          id: "variety",
          label: "Variety",
          name: "variety",
          options: varietys,
          selectedValue: null,
        },
        {
          id: "denimination",
          label: "Denomination",
          name: "denomination",
          options: denominations,
          selectedValue: null,
        },
        {
          id: "finish",
          label: "Finish",
          name: "finish",
          options: proofs,
          selectedValue: null,
        },
      ];

      this.isLoad = true;
      if (Object.keys(this.restoredFilters).length > 0) {
        this.applyRestoredFilters(this.restoredFilters);
      }
    });
  }

  applyRestoredFilters(restored: any) {
    if (!restored || Object.keys(restored).length === 0) return;

    this.filters = this.filters.map((filter) => {
      const restoredValue = restored[filter.name];

      if (restoredValue !== undefined && restoredValue !== null) {
        return {
          ...filter,
          selectedValue: restoredValue,
        };
      }
      return filter;
    });
  }

  onFilterChange() {
    const selectedFilters = this.filters.reduce((acc, filter) => {
      acc[filter.name] = filter.selectedValue;
      return acc;
    }, {});

    this.filtersChanged.emit(selectedFilters);
  }
}
